import React from "react";
import NumberFormat from "react-number-format";

import { BarChart, Bar, CartesianGrid, Tooltip, XAxis, YAxis, ResponsiveContainer, Label, Cell } from "recharts";

import styles from "./style.module.css";

class CustomToolTip extends React.Component {
  /*
  componentDidUpdate(prevProps) {
    const { label, payload, updateHoverValue, active } = this.props;

    if(active === false && prevProps.active === true) {
      updateHoverValue(undefined);
    }

    if (label && prevProps.label && label !== prevProps.label) {
      const field =
        payload && payload[0] && payload[0].payload
          ? payload[0].payload.field
          : undefined;
      const value =
        payload && payload[0] && payload[0].payload
          ? payload[0].payload.value
          : undefined;

      //this.props.updateHoverValue("ewewew");

      if (field && value) {
        updateHoverValue({
          field: field,
          value: value
        });
      }
    }
  }
  */

  render() {
    const { active, payload, hasProb, label, successStrings } = this.props;
    if (!active || !payload || !payload[0] || !payload[0].payload) {
      return null;
    }

    return payload.length === 1 ? (
      <div className={styles.cTooltip}>
        <div className={styles.tModel}>
          {payload[0].payload.value ? payload[0].payload.value : payload[0].payload.model}
        </div>
        {payload[0].payload.model && (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Model :"}</div>
            <strong>{payload[0].payload.model}</strong>
          </div>
        )}
        {payload[0].payload.field && (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{payload[0].payload.field + ": "}</div>
            <strong>{payload[0].payload.value}</strong>
          </div>
        )}
        {hasProb ? (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Prediction: "}</div>
            <strong>
              {payload[0].payload.prediction && payload[0].payload.prediction === "1.0"
                ? successStrings.positive
                : successStrings.negative}
            </strong>
          </div>
        ) : (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Prediction: "}</div>
            <strong>{successStrings.positive + " "}</strong>
            <NumberFormat
              value={payload[0].payload.prediction ? Number(payload[0].payload.prediction).toFixed(2) : ""}
              displayType={"text"}
              thousandSeparator={true}
              style={{ marginLeft: "5px" }}
            />
          </div>
        )}
        {hasProb && (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Prediction Score: "}</div>
            <strong>
              <NumberFormat
                value={payload[0].payload.probability ? Number(payload[0].payload.probability).toFixed(2) : ""}
                displayType={"text"}
                thousandSeparator={true}
              />
              {"%"}
            </strong>
          </div>
        )}
      </div>
    ) : (
      <div className={styles.cTooltip}>
        <div className={styles.tModel}>{payload[0].payload.value}</div>
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Prediction: "}</div>
          <strong>
            {payload[0].payload.prediction && payload[0].payload.prediction === "1.0"
              ? successStrings.positive
              : successStrings.negative}
          </strong>
        </div>
        {payload.map((p, index) => (
          <div className={styles.tBody} key={index}>
            <div className={styles.tLabel}>{p.name + ": "}</div>
            <strong>
              <NumberFormat value={p.value} displayType={"text"} thousandSeparator={true} />
            </strong>
          </div>
        ))}
      </div>
    );
  }
}

const CustomLabel = (props) => {
  const { active, payload, label } = props;

  return (
    <text textAnchor="start" className={styles.aLabel}>
      <tspan
        x={
          props.position === "insideTopLeft"
            ? props.value
              ? 250 / props.value.length
              : 20
            : props.viewBox.x + props.viewBox.width / 2 - 33
        }
        y={props.viewBox.y + props.offset}
      >
        {props.value}
      </tspan>
    </text>
  );
};

const RenderLegend = (props) => {
  const { successStrings } = props;

  return (
    <div className={styles.legendHolder}>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.positive} />
        <div>{successStrings.positive}</div>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.negative} />
        <div>{successStrings.negative}</div>
      </div>
    </div>
  );
};

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  const retVal = num.toString().match(re);
  return retVal ? reVal[0] : num;
}

class DriverGraph extends React.Component {
  render() {
    const { model, fieldSelect, featureBars } = this.props;

    if (model === undefined || featureBars === undefined) {
      return <div />;
    }

    const driver = featureBars.filter((f) => f.label === fieldSelect);

    const driverData = driver && driver.length > 0 ? driver[0] : undefined;

    if (driverData === undefined) {
      return <div />;
    }

    const data = Object.keys(driverData.values)
      .map((v, i) => ({
        Outcome: driverData.values[v],
        Values: v.replace(" ", "_").replace(" ", "_")
      }))
      .sort((a, b) => a.Outcome - b.Outcome);

    const xLabel = fieldSelect;
    const yLabel = "Outcome";

    let maxChars = xLabel ? xLabel.length - 10 : 0;

    data &&
      data.forEach((p) => {
        const val = String(p.Values);

        maxChars = Math.max(maxChars, val.length);
      });

    return (
      // <div className={styles.pDepChart} id="pdepChart">
      <ResponsiveContainer>
        <BarChart
          margin={{
            top: 20,
            right: 40,
            bottom: 100,
            left: maxChars * 6
          }}
          layout="vertical"
          data={data}
          onClick={() => {}}
        >
          <YAxis
            type="category"
            dataKey={"Values"}
            name={"Values"}
            tickFormatter={(tick) => {
              if (isNaN(tick)) {
                tick = String(tick).replace(/\ /g, "_");
                return tick;
              } else {
                return tick.toLocaleString();
              }
            }}
            label={<CustomLabel />}
          >
            <Label value={xLabel} position={"top"} />
          </YAxis>
          <XAxis
            type="number"
            dataKey={"Outcome"}
            name={"Outcome"}
            unit={""}
            tickFormatter={(tick) => (tick ? tick.toFixed(2) : "")}
          >
            <Label value={yLabel} offset={0} position="bottom" />
          </XAxis>
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Bar dataKey={"Outcome"}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.Outcome >= 0 ? "var(--aible-color)" : "#4ba6ba"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      // </div>
    );
  }
}

export default DriverGraph;
